import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {
  BenchlingAppType,
  BenchlingAppParentDependencyType,
  NestedParentDependencyType,
} from 'benchling-apps/BenchlingAppTypes';

import {ChildDependencyTypes} from './ChildDependencyTypes';
import ProcessTaskSchemaSubdependencyInput, {
  ProcessTaskSchemaOutputFieldInput,
} from './ProcessTaskSchemaSubdependencyInput';
import RequestSchemaSubdependencyInput from './RequestSchemaSubdependencyInput';
import ResultSchemaSubdependencyInput from './ResultSchemaSubdependencyInput';
import RunSchemaSubdependencyInput from './RunSchemaSubdependencyInput';
import SchemaFieldSelectorOptionInput from './SchemaFieldSelectorOptionInput';
import StorableSchemaSubdependencyInput from './StorableSchemaSubdependencyInput';
import TagSchemaFieldInput from './TagSchemaFieldInput';

export type BenchlingAppSubdependencyTableProps = ChildDependencyTypes & {
  type: BenchlingAppParentDependencyType | NestedParentDependencyType;
};

const SUPDEPENDENCY_INPUTS: {
  [k in BenchlingAppParentDependencyType | NestedParentDependencyType]: React.FC<ChildDependencyTypes>;
} = {
  [BenchlingAppType.dropdown]: SchemaFieldSelectorOptionInput,
  [BenchlingAppType.result_schema]: ResultSchemaSubdependencyInput,
  [BenchlingAppType.request_schema]: RequestSchemaSubdependencyInput,
  [BenchlingAppType.run_schema]: RunSchemaSubdependencyInput,
  [BenchlingAppType.entry_schema]: TagSchemaFieldInput,
  [BenchlingAppType.entity_schema]: TagSchemaFieldInput,
  [BenchlingAppType.box_schema]: StorableSchemaSubdependencyInput,
  [BenchlingAppType.container_schema]: StorableSchemaSubdependencyInput,
  [BenchlingAppType.location_schema]: StorableSchemaSubdependencyInput,
  [BenchlingAppType.plate_schema]: StorableSchemaSubdependencyInput,
  [BenchlingAppType.workflow_task_schema]: ProcessTaskSchemaSubdependencyInput,
  [NestedParentDependencyType.workflow_task_schema_output]: ProcessTaskSchemaOutputFieldInput,
};

export default function BenchlingAppSubdependencyTable({
  subdependencies,
  onChange,
  dependencyValidation,
  updateDependencyConfigValidation,
  disabled,
  type,
  parentDependencySelectedId,
}: BenchlingAppSubdependencyTableProps): JSX.Element {
  const Editor = SUPDEPENDENCY_INPUTS[type];
  return (
    <div {...getTestProps({component: 'BenchlingAppSubdependencyTable', element: 'root'})}>
      <Editor
        subdependencies={subdependencies}
        onChange={onChange}
        dependencyValidation={dependencyValidation}
        updateDependencyConfigValidation={updateDependencyConfigValidation}
        disabled={disabled}
        parentDependencySelectedId={parentDependencySelectedId}
      />
    </div>
  );
}
